import { Link, NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

const NAV = [
  { to: "/",         label: "Home" },
  { to: "/about",    label: "About" },
  { to: "/services", label: "Services" },
  { to: "/gallery",  label: "Gallery" },
  { to: "/contact",  label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const linkBase = "px-3 py-2 text-sm font-medium tracking-wide transition-colors duration-200";
  const idle = "text-crest-navy/80 hover:text-crest-green";
  const active = "text-crest-green";

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 w-full border-b border-border bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/75"
    >
      {/* Top utility bar */}
      <div className="hidden md:block bg-crest-green text-white text-xs">
        <div className="mx-auto max-w-7xl px-6 py-2 flex items-center justify-between font-body">
          <span className="tracking-[0.18em] uppercase text-white/80">
            {COMPANY.area}
          </span>
          <div className="flex items-center gap-5 text-white/90">
            <a href={COMPANY.phoneHref} className="hover:text-crest-gold transition-colors" data-testid="header-phone-link">
              <Phone className="inline h-3.5 w-3.5 mr-1.5 -mt-0.5" />{COMPANY.phone}
            </a>
            <span className="text-white/40">|</span>
            <span className="text-crest-gold/90">Free estimates · Fully insured · 30 yrs experience</span>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 flex items-center justify-between h-24 md:h-28">
        <Link to="/" className="flex items-center group" data-testid="header-logo-link">
          <div className="relative h-20 md:h-24 w-48 md:w-60 overflow-hidden">
            <img
              src={COMPANY.logoLight}
              alt="Cresttor Construction Ltd"
              className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-32 md:h-40 w-auto max-w-none"
            />
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) => `${linkBase} ${isActive ? active : idle}`}
              data-testid={`nav-${n.label.toLowerCase()}-link`}
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/contact#quote"
            className="ml-4 inline-flex items-center rounded-md bg-crest-green px-5 py-2.5 text-sm font-semibold text-white hover:bg-crest-green-700 transition-colors duration-200"
            data-testid="header-quote-cta"
          >
            Free Quote
          </Link>
        </nav>

        <button
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-md border border-border text-crest-navy"
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-white" data-testid="mobile-menu">
          <div className="mx-auto max-w-7xl px-4 py-4 flex flex-col">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) => `py-3 text-base font-medium border-b border-border last:border-0 ${isActive ? active : idle}`}
                data-testid={`mobile-nav-${n.label.toLowerCase()}-link`}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/contact#quote"
              onClick={() => setOpen(false)}
              className="mt-4 inline-flex items-center justify-center rounded-md bg-crest-green px-5 py-3 text-sm font-semibold text-white"
              data-testid="mobile-quote-cta"
            >
              Get a Free Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
